import prismjs from 'prismjs';
import 'prismjs/components/prism-php';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-markup-templating';
import 'prismjs/components/prism-yaml';
import 'prismjs/components/prism-typescript';
import 'prism-blade';

document.addEventListener('DOMContentLoaded', () => {
  prismjs.highlightAll();
});
